import { Dropdown, Select } from "@swivl-mono/ui";

import VarsModel from "../../../Models/Variables/VarsModel.Model";

interface Props {
  prependOptions?: any[];
  skipUserId?: boolean;
  skipLastUserInput?: boolean;
  addMarkup?: boolean;
  includeURLPath?: boolean;
  skipBotVariables?: boolean;
  value?: string;
  name?: string;
  onChange?: any;
}

export default function UserVariablesDropdown(props: Props) {
  let options = props.prependOptions ? props.prependOptions : [];
  const uvVariables = VarsModel.variableOptions(
    props.skipUserId,
    props.skipLastUserInput,
    props.addMarkup,
    props.includeURLPath,
    props.skipBotVariables
  );
  options = options.concat(uvVariables);
  const value = props.value?.replace("#*", "").replace("*#", "");

  const handleChange = (selected: string[]) => {
    if (props.onChange) {
      props.onChange({ target: { name: props.name, value: selected[0] } });
    }
  };

  return (
    <Select hideClear options={options} selectedValues={value ? [value] : undefined} name={props.name} onChange={handleChange} hasSearchInDropdown />
  );
}
